/**
 * 提供询获取报价时,获取显示哪次报价为最新的状态的服务
 * 该服务会把每次获取到的报价列表以 quoteListCache + 行程id + 用户id 为标识存储到 localStorage中,每次会根据数据变化做更新
 * @module  pollQuoteService
 * @see 文档: http://i.shijiebang.net/wiki/pages/viewpage.action?pageId=12394536
 * @author ianva
 */

var store = require('store');
var _ = require('underscore');


/**
 * 格式化为 {inquiryKey, versionids, updateVersionIds, isNew, isExpired }
 */
var _formatQuoteList = function(quoteListData){

    return quoteListData.map((item)=>{

        return {
            inquiryKey: item.inquiryKey,
            versionIds: item.priceCalenderDataList.map((cell)=>{
                    return cell.versionId
                }),
            updateVersionIds:[],
            isExpired: item.isExpired,
            isNew : false
        };

    })

};


/**
 * 获取更新后的报价列表（更新 versionids , isNew）
 * @param {Array} target 之前的报价列表
 * @param {Array} src 新的报价列表
 * @return {Array} 更新后的报价列表
 */
var _getUpdatedQuoteList = function(target, src){

    if( src ){

        return src.map((item)=>{

            var targetItem = _.findWhere(target,{ inquiryKey: item.inquiryKey });

            /**
             * 第一次获取报价列表
             */
            if( ! targetItem ){

                item.updateVersionIds = item.versionIds.filter(id=>!/-/.test(id));

                if( item.updateVersionIds.length ){
                    item.isNew = true;
                }

                return item

            }

            /**
             * 报价过期
             */
            if( item.isExpired ){
                item.isNew = false;
                item.updateVersionIds = [];
                return item
            }

            /**
             * version 产生变化时才变更 versionid
             */
            var updateVersionIds = _.difference( item.versionIds, targetItem.versionIds );

            if( updateVersionIds.length ){
                item.isNew = true;
                item.updateVersionIds = _.compact(_.union(targetItem.updateVersionIds,updateVersionIds));
            }else{
                item.isNew = targetItem.isNew;
                item.updateVersionIds = targetItem.updateVersionIds || [];
            }

            return item

        });

    }

    return target
};

/**
 * 行程id + 用户 id
 */
var _uuid = 0;

/**
 * 清除本地存储中空的报价列表
 */
var cleanEmpty = function (cacheName) {

    var cacheNameReg = new RegExp(cacheName);

    store.forEach(function (key,value) {
        if( cacheNameReg.test(key)  && value.length === 0 ){
            store.remove(key)
        }
    });

};

var pollQuoteService = {

    /**
     * 初始化,需要设定 trip id
     */
    init(tripID,uid){

        _uuid = tripID + '-' + uid

        cleanEmpty('quoteListCache');

    },
    getID(){
        return _uuid;
    },
    /**
     * 获取报价列表
     */
    getQuoteList(){
        return store.get('quoteListCache' + _uuid)
    },
    /**
     * 存报价列表
     */
    _setQuoteList(quoteList){

        store.set('quoteListCache'+ _uuid ,quoteList);

    },
    /**
     * 保存报价列表
     */
    saveQuoteList(quoteListData){

        var newQuoteList = _formatQuoteList(quoteListData);
        var oldQuoteList = this.getQuoteList();

        if( oldQuoteList ){
            this._setQuoteList(_getUpdatedQuoteList(oldQuoteList,newQuoteList))
        }else{
            this._setQuoteList(_getUpdatedQuoteList(newQuoteList));
        }

    },
    /**
     * 获取更新的报价（versionid）
     */
    getNewVersions(){

        var quotes = this.getQuoteList();

        if( quotes ){

            return _.compact(_.flatten(quotes.map((item)=>{
                return item.updateVersionIds
            })))
        }

        return []
    },
    /**
     * 获取更新的报价列表 id
     */
    getNewQuotes(){

        var quotes = this.getQuoteList();

        if( quotes  ){

            return quotes.filter((item)=>{
                return item.isNew
            }).map((item)=>{
                return item.inquiryKey
            })
        }

        return []

    },
    /**
     * 取消指定报价列表的的 news 状态
     * @param {String} 报价 inquiryKey
     */
    cancelNewQuote(inquiryKey){


        var newQuoteList =  this.getQuoteList().map((item)=>{

            if( item.inquiryKey === inquiryKey ){
                item.isNew = false;
                item.updateVersionIds = [];
            }

            return item

        });

        this._setQuoteList(newQuoteList);
    }
};

module.exports = pollQuoteService;



/** WEBPACK FOOTER **
 ** ./script/detail/pollQuoteService.js
 **/